<main class="main">
  <div class="content">
      <div id="swagger-ui"></div>
  </div>
</main>